import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateInput } from 'semantic-ui-calendar-react'
import ProfileSettingsService from '~/api/services/profileSettings'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import TwoFaComp, { LabelTwoFaType } from '~/components/TwoFaComp'
import { useAuth } from '~/routes/components/AuthProvider'
import { getDateWithoutTime, handleErrors } from '~/utils/helpers'
import { StyledDateWrapper } from './style'

interface Props {
  selectedMonth: string
  openGeneratingModal: boolean
  handleClose: () => void
  handleGenerateInvoice: (data?) => void
}

const GenerateMilkBill: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { systemData, systemData: { languages, logged: { languageId } } } = useAuth()
  const { selectedMonth, openGeneratingModal, handleClose, handleGenerateInvoice } = props
  const tfaGenerateMga = systemData?.roleSettings?.tfaGenerateMga === 1
  const tfaType = systemData?.logged?.tfaType
  const languageLocal = languages.find(language => language.id === languageId)

  const [isBusy, setIsBusy] = useState(false)
  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')
  const [date, setDate] = useState('')

  useEffect(() => {
    if (tfaGenerateMga && openGeneratingModal) {
      handleSendCode()
    }
  }, [openGeneratingModal])

  async function handleSendCode() {
    if (tfaType === 'email' || tfaType === 'sms') {
      setIsBusy(true)
      try {
        await ProfileSettingsService.sendCode()
        notify(t('Code sent'), 'success')
      } catch (error) {
        handleErrors(error)
      }
      setIsBusy(false)
    }
  }

  function renderContent() {
    const startOfPreviousMonth = dayjs().subtract(1, 'month').startOf('month').format('DD.MM.YYYY');
    const endOfMonth = dayjs().endOf('month').format('DD.MM.YYYY');
    return <div>
      <div style={{ marginBottom: '1em' }}>{t('With this process step, the milk payment statement is generated for all farmers. You then have the opportunity to preview the farmers \n\
    individual milk payment statements.If you would like to make further changes(e.g.item bookings, adjusting milk deliveries, etc.), \n\
    these will be updated immediately after the change.Please click on “Create MGA” to initiate the process.Click “Cancel” if you don’ t want to do this.')}</div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 50, justifyContent: 'center' }}>
        <StyledDateWrapper>
          <label>
            <div style={{ color: '#5e6672' }}>{t('Invoice date for the MGA')}<span style={{ color: 'red' }}>*</span>:</div>
          </label>
          <DateInput
            name='date'
            autoComplete='off'
            inlineLabel
            minDate={startOfPreviousMonth}
            maxDate={endOfMonth}
            placeholder={t('Date')}
            pickerStyle={{ width: '230px' }}
            closable
            clearIcon={'close'}
            localization={languageLocal.code}
            closeOnMouseLeave={false}
            dateFormat={'DD.MM.YYYY'}
            className={'datePicker'}
            value={date}
            iconPosition='left'
            onChange={(event, { name, value }) => setDate(value)}
          />
        </StyledDateWrapper>
        {tfaGenerateMga && <TwoFaComp
          onChangeTfaCode={(code) => setTfaCode(code)}
          type={LabelTwoFaType.Top}
          disableMarginTop
          onChangeCorrectTfaCode={(correctTfaCode) => setCorrectTfaCode(correctTfaCode)}
        />
        }
      </div>
    </div >
  }

  const dateParsed = dayjs(getDateWithoutTime(date)).format('YYYY-MM-DD')

  return <Dialog
    isDialogOpen={openGeneratingModal}
    handleClose={() => handleClose()}
    textHeader={t('Process start: Generate milk bill for {{month}}', { month: selectedMonth })}
    textSubmit={t('Create MGA')}
    isLoading={isBusy}
    textClose={t('Cancel')}
    disableSubmit={tfaGenerateMga ? !correctTfaCode || !date : !date}
    handleSubmit={() => handleGenerateInvoice(tfaGenerateMga ?
      { code: tfaCode, date: dateParsed } :
      { date: dateParsed })}
    style={{ width: 700 }}
    type={'abort'}
    textContent={renderContent()}
  />
}
export default GenerateMilkBill